import IconCloud01 from '@patientpattern/coat/icons/line/weather/Cloud01';
import Text from '@patientpattern/coat/ui/Text';
import {cnb} from 'cnbuilder';
import * as PropTypes from 'prop-types';
import {isRouteErrorResponse, useRouteError} from 'react-router-dom';

import css from './ErrorDisplayBoundary.module.scss';

const ErrorDisplayBoundary = ({
    classNameRoot,
    testAttrRoot,
    testAttrMessage,
    message,
}) => {
    const error = useRouteError();
    const msg =
        isRouteErrorResponse(error) ?
            `${error.status}: ${error.data?.message}`
        :   message;

    return (
        <div className={cnb(css.root, classNameRoot)} data-test={testAttrRoot}>
            <div className={css.icon}>
                <IconCloud01 className={css.cloud} />
            </div>
            <Text as="h1" size="xl" weight="medium">
                An error occurred
            </Text>
            {msg && <Text data-test={testAttrMessage}>{msg}</Text>}
            <Text>
                Please refresh the page and try again or{' '}
                <a href="mailto:support@patientpattern.com">contact support</a>.
            </Text>
        </div>
    );
};

ErrorDisplayBoundary.propTypes = {
    classNameRoot: PropTypes.string,
    message: PropTypes.string,
    testAttrMessage: PropTypes.string,
    testAttrRoot: PropTypes.string,
};

ErrorDisplayBoundary.defaultProps = {
    testAttrMessage: 'error-display-boundary-message',
    testAttrRoot: 'error-display-boundary-root',
};

export default ErrorDisplayBoundary;
